import React, { useState } from "react";
import { Popover, Button } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { FaRegUser, FaRegCommentDots, FaRegCreditCard, FaPlus } from "react-icons/fa6";
import { GoGear } from "react-icons/go";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { HiOutlineLogout } from "react-icons/hi";


const ProfileContent = ({ setOpen }) => {
    const navigate = useNavigate();

    return (
        <div className="w-[190px] text-sm font-sans">
            {/* Profile */}
            <div
                onClick={() => {
                    setOpen(false);
                    navigate("/DoctorsideProfile");
                }}
                className="flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-gray-100"
            >
                <i class="fa-regular fa-user" style={{ fontSize: "14px" }}></i>
                <span>Profile</span>
            </div>

            {/* Community */}
            {/* <div className="flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-gray-100">
                <FaRegCommentDots size={14} />
                <span>Community</span>
            </div> */}

            {/* Subscription with PRO badge */}
            {/* <div className="flex items-center justify-between px-3 py-2 rounded cursor-pointer hover:bg-gray-100">
                <div className="flex items-center gap-2">
                    <FaRegCreditCard size={14} />
                    <span>Subscription</span>
                </div>
                <span className="text-[0.65rem] font-semibold px-1.5 py-[2px] rounded bg-[#fcefff] text-[#c724d6] flex items-center gap-1">
                    <FaPlus className="text-xs" />
                    PRO
                </span>
            </div> */}

            {/* Settings */}
            {/* <div className="flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-gray-100">
                <GoGear size={16} />
                <span>Settings</span>
            </div> */}

            {/* Help Center */}
            {/* <div className="flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-gray-100">
                <IoMdInformationCircleOutline size={16} />
                <span>Help center</span>
            </div> */}

            {/* Sign Out */}
            <Link
                to="/SignIn"
                onClick={() => setOpen(false)}
                className="no-underline text-gray-800"
            >
                <div className="flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-gray-100">
                    <HiOutlineLogout size={16} />
                    <span>Sign out</span>
                </div>
            </Link>
        </div>
    );
};

const DoctorProfilePopover = () => {
    const [open, setOpen] = useState(false);

    return (
        <Popover
            content={<ProfileContent setOpen={setOpen} />}
            trigger="click"
            open={open}
            onOpenChange={() => setOpen(!open)}
            placement="bottomRight"
        >
            <Button icon={<FaRegUser size={13} />} />
        </Popover>
    );
};

export default DoctorProfilePopover;
